import {Component, OnInit} from '@angular/core';
import {Router, RouterLink, RouterOutlet} from '@angular/router';
import {Toolbar} from 'primeng/toolbar';
import {Button} from 'primeng/button';
import {environment} from '../environments/environment';
import {version} from '../environments/version';
import {buildnumber} from '../environments/buildnumber';
import {PrimeTemplate} from 'primeng/api';
import {SystemService} from './services/SystemService';
import {TranslocoPipe, TranslocoService} from '@ngneat/transloco';
import {SelectChangeEvent} from 'primeng/select';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'forms-builder-app-root',
  imports: [
    RouterOutlet,
    Toolbar,
    Button,
    RouterLink,
    PrimeTemplate,
    TranslocoPipe,
    FormsModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class FormsBuilderAppComponent implements OnInit {

  public version = version + "." + buildnumber;

  public langs = [
    {value: "en", label: "English"},
    {value: "he", label: "עברית"},
    {value: "ua", label: "Українська"},
  ]

  public lang = "en"

  constructor(
    sysvc: SystemService,
    private router: Router,
    private t: TranslocoService,
  ) {
    sysvc.Init()
  }

  ngOnInit(): void {
    this.lang = this.t.getActiveLang();
    if (!localStorage.getItem('apiToken')) {
      this.router.navigate(['/login']).then();
    } else {
      fetch(environment.api + '/api/auth?token=' + localStorage.getItem('apiToken'))
        .then(response => response.json())
        .then(status => {
          if (!status) {
            localStorage.removeItem('apiToken');
            this.router.navigate(['/login']).then();
          }
        });
    }
  }

  public isLoggedIn(): boolean {
    return localStorage.getItem('apiToken') !== null;
  }

  chlang($event: SelectChangeEvent) {
    this.t.setActiveLang($event.value);
  }

  testException() {
    throw new Error("Test exception")
  }
}
